import React, { useState } from 'react';
import { User } from '../types';

type Props = {
    users: User[];
    self: User | null;
    activeChatEmail: string | null;
    onSelect: (email: string | null) => void;
    unreadCounts: { [key: string]: number };
};

const ChatSidebar: React.FC<Props> = ({ users, self, activeChatEmail, onSelect, unreadCounts }) => {
    const generalUnread = unreadCounts['general'] || 0;
    const [searchTerm, setSearchTerm] = useState('');

    const sortedUsers = [...users].sort((a, b) => {
        const unreadA = unreadCounts[a.email] || 0;
        const unreadB = unreadCounts[b.email] || 0;

        if (unreadA > 0 && unreadB === 0) return -1;
        if (unreadB > 0 && unreadA === 0) return 1;

        return a.name.localeCompare(b.name);
    });

    const filteredUsers = sortedUsers.filter(u =>
        u.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="sidebar">
            <div
                className={`sidebar-item ${activeChatEmail === null ? 'active' : ''}`}
                onClick={() => onSelect(null)}
                style={{ fontWeight: generalUnread > 0 ? 'bold' : 'normal' }}
            >
                General Chat {generalUnread > 0 ? `(${generalUnread})` : ''}
            </div>
            <input
                type="text"
                placeholder="Search users..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="user-search-input"
                style={{
                    width: '90%',
                    margin: '10px auto',
                    display: 'block',
                    padding: '5px',
                    borderRadius: '4px',
                    border: '1px solid #ccc'
                }}
            />
            {filteredUsers.map(u => {
                const unread = unreadCounts[u.email] || 0;
                return (
                    <div
                        key={u.email}
                        className={`sidebar-item ${activeChatEmail === u.email ? 'active' : ''}`}
                        onClick={() => onSelect(u.email)}
                        style={{ fontWeight: unread > 0 ? 'bold' : 'normal' }}
                    >
                        <img
                            src={u.imageUrl || 'https://lavnch.com/wp-content/uploads/2020/12/cropped-lavnch-site-icon.png'}
                            onError={(e) => {
                              const target = e.target as HTMLImageElement;
                              target.onerror = null;
                              target.src = 'https://lavnch.com/wp-content/uploads/2020/12/cropped-lavnch-site-icon.png';
                            }}
                            alt={u.name}
                            className="avatar"
                        />
                        {u.name} {self?.email === u.email ? '(You)' : ''} {unread > 0 ? `(${unread})` : ''}
                    </div>
                );
            })}
        </div>
    );
};

export default ChatSidebar;
